<app-season-base-form-header translationKey="budget" [enableIcon]="enableIcon()" [(isDisabled)]="isDisabled" />
<form class="flex flex-col" [formGroup]="budget()">
    <div class="mt-6 mb-10 w-2/5">
        <!-- Budget for Calendar Year -->
        <sh-input-text
            class="p-0 border-0"
            formControlName="totalBudget"
            [label]="calendarYearBudgetLabel | translate"
            [disabled]="isDisabled()"
            mandatory
            (keydown)="preventNonNumericInput($event)"
        >
            <span slot="icon" class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center">
                €
            </span>
        </sh-input-text>
    </div>

    <div class="border-b border-customBorder pb-2 mb-4 w-3/5" formGroupName="employee">
        <!-- Employee -->
        <p class="text-lg pb-4 text-budgetInputGroupLabelColor">
            {{ 'seasons.season-creation.budget.employee' | translate }}
        </p>
        <!-- 2 inputs with labels -->
        <div class="flex flex-row justify-between">
            <div class="pr-4 pb-2 w-full" formGroupName="firstSubsidy">
                <sh-input-text
                    class="p-0 border-0"
                    [label]="shortestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
            <div class="pb-2 w-full" formGroupName="secondSubsidy">
                <sh-input-text
                    class="p-0 border-0"
                    [label]="longestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
        </div>
    </div>

    <div class="border-b border-customBorder pb-2 mb-4 w-3/5" formGroupName="spouse">
        <!-- Spouse -->
        <p class="text-lg pb-4 text-budgetInputGroupLabelColor">
            {{ 'seasons.season-creation.budget.spouse' | translate }}
        </p>
        <!-- 2 inputs with labels -->
        <div class="flex flex-row justify-between">
            <div class="pr-4 pb-2 w-full" formGroupName="firstSubsidy">
                <sh-input-text
                    class="pr-4w-full p-0 border-0"
                    [label]="shortestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
            <div class="pb-2 w-full" formGroupName="secondSubsidy">
                <sh-input-text
                    class="w-full p-0 border-0"
                    [label]="longestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
        </div>
    </div>

    <div class="mb-4 w-3/5" formGroupName="child">
        <p class="text-lg pb-4 text-budgetInputGroupLabelColor">
            {{ 'seasons.season-creation.budget.child' | translate }}
        </p>
        <div class="flex flex-row justify-between">
            <div class="pr-4 w-full" formGroupName="firstSubsidy">
                <sh-input-text
                    class="w-full p-0 border-0"
                    [label]="shortestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
            <div class="w-full" formGroupName="secondSubsidy">
                <sh-input-text
                    class="w-full p-0 border-0"
                    [label]="longestSubsidyLabel | translate"
                    formControlName="amount"
                    [disabled]="isDisabled()"
                    mandatory
                    (keydown)="preventNonNumericInput($event)"
                >
                    <span
                        slot="icon"
                        class="text-budgetInputGroupLabelColor pr-4 h-full flex items-center justify-center"
                    >
                        €
                    </span>
                </sh-input-text>
            </div>
        </div>
    </div>
</form>
